// @flow
import type { Action } from 'app/common/redux/types';

export type State = {
  userInfo: {},
};

const loggedOutUserInfoReducer = (state: State = { userInfo: {} }, action: Action): State => {
  if (action.type === 'LOGGED_OUT_USER_INFO_FOUND') {
    return { userInfo: action.payload };
  } else if (action.type === 'LOGGED_OUT_USER_INFO_NOT_FOUND') {
    return { userInfo: {} };
  }
  return state;
};

export default loggedOutUserInfoReducer;
